/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect, useRef } from "react";
import { Input, Select, Modal } from "antd";
import Cookies from "js-cookie";
import ServiceApi from "../../../../services/ServiceApi";
import { isMobile } from "react-device-detect";

const { Option } = Select;
// const { TextArea } = Input;
const content = {
  soid: {
    label: "S/O ID",
    show: true,
    value: "",
  },
  sotype: {
    label: "S/O Type",
    show: true,
    value: "",
    option: [
      { label: "xx", value: "xx" },
      { label: "xxx", value: "xxx" },
      { label: "xxxx", value: "xxxx" },
    ],
  },
  jobid: {
    label: "Job ID",
    show: false,
    value: "",
  },
  sapid: {
    label: "SAP ID",
    show: false,
    value: "",
  },
  workcenter: {
    label: "Work Center",
    show: true,
    value: "",
    option: [
      { label: "xx", value: "xx" },
      { label: "xxx", value: "xxx" },
      { label: "xxxx", value: "xxxx" },
    ],
  },
  subcenter: {
    label: "Sub Center",
    show: true,
    value: "",
  },
  alarmtype: {
    label: "Alarm Type",
    show: true,
    value: "",
    option: [
      { label: "xx", value: "xx" },
      { label: "xxx", value: "xxx" },
      { label: "xxxx", value: "xxxx" },
    ],
  },
  alarmdata: {
    label: "Alarm Data",
    show: true,
    value: "",
  },
};
export default function JobDetail({
  CompanyId,
  OperatorId,
  ProjectId,
  title,
  iscopy,
  formdata,
  setformdata,
  valuechange,
  selectchange,
  language,
  factupdate,
  updatejobcategory,
  updatejobtype,
  selectjobcat,
  updatesla,
  sla,
  slatime,
  jobcatselect,
}) {
  const priority = jobcatselect;
  const locale = Cookies.get("locale");
  const [Jobcategory, setJobcategory] = useState([]);
  const [currentJobCat, setcurrentJobCat] = useState(
    Number(formdata.job_cat_id)
  );
  const [masterSapType, setmasterSapType] = useState([]);
  const [Jobtype, setJobtype] = useState([]);
  const unmounted = useRef(false);
  const [loadingJobType, setLoadingJobType] = useState(false);
  const [loadingJobSubType, setLoadingJobSubType] = useState(false);
  const [isClickFromJobCat, setIsClickFromJobCat] = useState(false);
  // console.log("formdata", formdata);
  useEffect(() => {
    ServiceApi.post("get_job_category_V2", {
      company_id: CompanyId,
      operator_id: OperatorId,
      project_id: ProjectId,
      job_category_id: null,
      is_active: 1,
      date_active: 1,
    })
      .then((response) => {
        setJobcategory(response.data.data.result_data);
      })
      .catch((e) => {
        console.log(e);
      });
    if (Number(formdata.job_type_id) && Number(formdata.job_cat_id)) {
      callJobType(Number(formdata.job_cat_id), Number(formdata.job_type_id));
      // Setdata_jobtype(Number(formdata.job_type_id));
      setcurrentJobCat(Number(formdata.job_cat_id));
    }
    return () => {
      unmounted.current = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // useEffect(() => {
  //   callJobType(currentJobCat,'');
  // }, [currentJobCat])

  const callJobType = async (n, jobTypeId) => {
    setLoadingJobType(true);
    setLoadingJobSubType(true);
    // console.log("callJobType > jobTypeId", jobTypeId);
    ServiceApi.post("V4/get_job_type", {
      pk_id: null,
      fk_id: n,
      is_active: "1",
      effective: "1",
      sql_where: null,
      company_id: CompanyId,
      operator_id: OperatorId,
      project_id: ProjectId,
      UserName: Cookies.get("username"),
    })
      .then((response) => {
        let jobTypeIdValue = jobTypeId;
        setJobtype(response.data.data);
        if (jobTypeId !== "") {
          Setdata_jobtype({ jobCatValue: n, jobTypeIdValue: jobTypeId });
        } else {
          if (response.data.data.length > 0) {
            jobTypeIdValue = response.data.data[0].job_type_id;
            Setdata_jobtype({ jobCatValue: n, jobTypeIdValue: jobTypeIdValue });
            console.log("jobTypeId >>>>", response.data.data[0].job_type_id);
          }
        }
        setformdata((Formdata) => ({
          ...Formdata,
          job_type_id: jobTypeIdValue,
        }));
        setLoadingJobType(false);
      })
      .catch((e) => {
        console.log(e);
      });
    setcurrentJobCat(n);
    updatejobcategory(n);
  };
  /* job cat menu */
  const job_cat_btn = Jobcategory.map((job_cat, index) => {
    let thismr = "";
    if ((index + 1) % 5 === 0 && index !== 0) {
      thismr = "mr-2 ";
    }

    if (Jobcategory.length === 1) {
      return (
        <div
          key={index + 54547}
          className={"col-lg-3 " + thismr + "p0"}
          style={{ marginBottom: "10px" }}
        >
          <button
            disabled={formdata.IsHold || false}
            type="button"
            className={
              currentJobCat === job_cat.job_category_id
                ? "btndetailshow"
                : "btndetailhide"
            }
            onLoad={callJobType.bind(
              this,
              job_cat.job_category_id,
              Number(formdata.job_type_id)
            )}
          >
            <img
              style={{
                float: "right",
                marginRight: "10px",
              }}
              src={
                currentJobCat == job_cat.job_category_id
                  ? ServiceApi.absoluteUrl("/icon/job_show.svg")
                  : ServiceApi.absoluteUrl("/icon/job_dis.svg")
              }
            />
            <br className="mt-2" />
            <img
              style={{
                float: "center",
                marginLeft: "-15px",
              }}
              src={ServiceApi.absoluteUrl("/icon/" + job_cat.icon_name)}
            />
            <span
              style={{
                marginLeft: "-20px",
                fontSize: "14px",
                color: "#0500A3",
              }}
            >
              <br className="mt-2" />
              {job_cat.job_category_name}
            </span>
          </button>
        </div>
      );
    } else {
      return (
        <div
          key={index + 54547}
          className={"col-3 " + thismr + "p0"}
          style={{ marginBottom: "10px" }}
        >
          <button
            disabled={formdata.IsHold || false}
            style={{
              backgroundColor: formdata.IsHold ? "#f3f3f3" : "white",
            }}
            type="button"
            className={
              currentJobCat === job_cat.job_category_id
                ? "btndetailshow"
                : "btndetailhide"
            }
            onClick={callJobType.bind(this, job_cat.job_category_id, "")}
            // onClick={() => {
            //   setcurrentJobCat(job_cat.job_category_id);
            //   updatejobcategory(job_cat.job_category_id);
            // }}
          >
            <img
              style={{
                float: "right",
                marginRight: "10px",
              }}
              src={
                currentJobCat === job_cat.job_category_id
                  ? ServiceApi.absoluteUrl("/icon/job_show.svg")
                  : ServiceApi.absoluteUrl("/icon/job_dis.svg")
              }
            />
            <br className="mt-2" />
            <img
              style={{
                float: "center",
                marginLeft: "-15px",
              }}
              src={ServiceApi.absoluteUrl("/icon/" + job_cat.icon_name)}
            />
            <span
              style={{
                marginLeft: "-20px",
                fontSize: "14px",
                color: "#0500A3",
              }}
            >
              <br className="mt-2" />
              {job_cat.job_category_name}
            </span>
          </button>
        </div>
      );
    }
  });
  const [selected_jobtype, setselected_jobtype] = useState(null);
  const [sub_type, setsub_type] = useState([]);
  const [Work_center, setWork_center] = useState([]);
  const [Alarmtype, setAlarmtype] = useState([]);

  const Setdata_jobtype = async ({ jobCatValue, jobTypeIdValue }) => {
    setLoadingJobSubType(true);
    ServiceApi.post("get_job_sub_type", {
      job_sub_type_id: null,
      job_category_id: jobCatValue, //currentJobCat,
      job_type_id: jobTypeIdValue,
      is_active: 1,
      effective: 1,
      sql_where: " and company_id=" + CompanyId,
      operator_id: OperatorId,
      // sql_where: null,
    })
      .then((response) => {
        setselected_jobtype(jobTypeIdValue || null);
        setsub_type(response.data.data.job_sub_type_dto_list);

        if (response.data.data.job_sub_type_dto_list.length > 0) {
          const jobSubTypeObj = response.data.data.job_sub_type_dto_list.find(
            (e) => e.job_sub_type_id === formdata.job_sub_type_id
          );

          if (jobSubTypeObj) {
            SetJobsubtype(jobSubTypeObj.job_sub_type_id);
          } else {
            SetJobsubtype(
              response.data.data.job_sub_type_dto_list[0].job_sub_type_id
            );
          }
        } else {
          SetJobsubtype(null);
        }

        setLoadingJobSubType(false);
      })
      .catch((e) => {
        console.log(e);
      });
    updatejobtype(jobTypeIdValue);
    setformdata((Formdata) => ({
      ...Formdata,
      job_type_id: jobTypeIdValue,
    }));

    /* get sla level */
    ServiceApi.post("master_data/sla_single", {
      company_id: CompanyId,
      operator_id: OperatorId,
      project_id: ProjectId,
      job_category_id: jobCatValue,
      job_type_id: jobTypeIdValue,
    })
      .then((res) => {
        updatesla(res.data.data.result);
        // console.log(`sla`, res.data.data.result);
      })
      .catch((e) => {
        console.log(e);
      });
    /* get prority  */
    ServiceApi.post("master_data/priority_single", {
      company_id: CompanyId,
      operator_id: OperatorId,
      project_id: ProjectId,
      job_category_id: jobCatValue,
      job_type_id: jobTypeIdValue,
    })
      .then((res) => {
        selectjobcat(res.data.data.result);
        // console.log(`priority`, res.data.data.result);
      })
      .catch((e) => {
        console.log(e);
      });
    /* get workcenter */
    ServiceApi.post("master_data/work_center_single", {
      company_id: CompanyId,
      is_active: 1,
      where: "",
    })
      .then((res) => {
        setWork_center(res.data.data.result);
        // console.log(`workcenter`, res.data.data.result);
      })
      .catch((e) => {
        console.log(e);
      });

    /* getAlarmType */
    ServiceApi.post("master_data/alarm_type_single", {
      company_id: CompanyId,
      operator_id: OperatorId,
      project_id: ProjectId,
      is_activ: 1,
      where: "",
    })
      .then((res) => {
        setAlarmtype(res.data.data.result);
      })
      .catch((e) => {
        console.log(e);
      });

    // saptype
    ServiceApi.post("master_data/get_sap_type", {
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
    }).then((res) => {
      const { result, data } = res.data;
      if (result.code === "P") {
        setmasterSapType(data?.result);
      }
    });
  };

  const SetJobsubtype = (value) => {
    setselected_jobtype(value);
    setformdata((Formdata) => ({
      ...Formdata,
      job_sub_type_id: value,
    }));
  };
  return (
    <div
      className="col-lg-7 mt-4 pb-5 mr-4 ml-4"
      style={{ backgroundColor: "#FFFFFF", borderRadius: "5px" }}
    >
      <div className="row mt-3">
        <img src={ServiceApi.absoluteUrl("/icon/job_detail.svg")}></img>
        <span className="font-thai-b fs-22 ml-2 mb-1">{title}</span>
      </div>
      <div className="row">
        <div className="col-12">
          <div>
            <div className="row">
              <label className="font-thai-r fs-18 c-gray">
                {factupdate ? language[locale]["job_category"] : `Job Category`}
                <b style={{ color: "#DF4547" }} className="ml-1">
                  *
                </b>
              </label>
            </div>
            <div className="row">{job_cat_btn}</div>
          </div>
          <div className="row d-flex justify-content-left">
            {/* job type */}
            <div className="col-lg-4 mr-4">
              <div className="row">
                <span className="font-thai-r fs-18 c-gray">
                  {factupdate ? language[locale]["job_type"] : `Job Type`}
                  <b style={{ color: "#DF4547" }}> * </b>
                </span>
              </div>
              <div className="row">
                <Select
                  disabled={loadingJobType || formdata.IsHold || false}
                  loading={loadingJobType}
                  name="jobtype"
                  // defaultValue={
                  //   formdata.job_type_id !== ""
                  //     ? formdata.job_type_id
                  //     : "Pleace Select"
                  // }
                  value={
                    formdata.job_type_id !== ""
                      ? formdata.job_type_id
                      : "Pleace Select"
                  }
                  style={{ width: "100%" }}
                  className="dropdrowtype font-thai-r"
                  onChange={(value) =>
                    Setdata_jobtype({
                      jobCatValue: currentJobCat,
                      jobTypeIdValue: value,
                    })
                  }
                >
                  {Jobtype.map((data, index) => (
                    <Option
                      key={`jobtype_option_a_${index}`}
                      value={data.job_type_id}
                    >
                      {data.job_type_name}
                    </Option>
                  ))}
                </Select>
              </div>
            </div>
            {/* job sub type */}
            <div className="col-lg-2 mr-2">
              <div className="row">
                <span className="font-thai-r fs-18 c-gray">
                  {factupdate
                    ? language[locale]["job_sub_type"]
                    : `Job Sub Type`}
                  <b style={{ color: "#DF4547" }}> * </b>
                </span>
              </div>
              <div className="row">
                <Select
                  loading={loadingJobSubType}
                  disabled={loadingJobSubType || formdata.IsHold || false}
                  name="jobsubtype"
                  value={
                    formdata.job_sub_type_id !== ""
                      ? formdata.job_sub_type_id
                      : "Pleace Select"
                  }
                  style={{ width: "100%" }}
                  className="dropdrowtype font-thai-r"
                  onChange={(value) => SetJobsubtype(value)}
                >
                  {sub_type.map((data, index) => (
                    <Option
                      key={`jobtype_option_a_${index}`}
                      value={data.job_sub_type_id}
                    >
                      {data.job_type_name}
                    </Option>
                  ))}
                </Select>
              </div>
            </div>
            {/* saptype */}
            <div className="col-lg-2 mr-2">
              <div className="row">
                <span className="font-thai-r fs-18 c-gray">
                  {factupdate
                    ? language[locale]["job_sap_type"]
                    : `Job Sap Type`}
                </span>
              </div>
              <div className="row">
                <Select
                  disabled={formdata.IsHold || false}
                  name="saptype"
                  defaultValue={
                    formdata.saptype !== "" ? formdata.saptype : "Pleace Select"
                  }
                  style={{ width: "100%" }}
                  className="dropdrowtype font-thai-r"
                  onChange={selectchange.bind(this, "saptype")}
                >
                  {masterSapType.map((data, index) => (
                    <Option
                      key={`job_sap_type_option${index}`}
                      value={data.sap_type_id}
                    >
                      {data.sap_type_name}
                    </Option>
                  ))}
                </Select>
              </div>
            </div>
          </div>
          {!iscopy ? (
            <div className="row d-flex justify-content-left">
              <div className="col-lg-4 mr-4">
                <div className="row">
                  <span className="font-thai-r fs-18 c-gray">
                    {factupdate
                      ? language[locale]["job_no"]
                      : content.soid.label}
                  </span>
                </div>
                <div className="row">
                  <Input
                    name="jobno"
                    className="inputfile c-blue"
                    value={formdata.job_no}
                    disabled
                  ></Input>
                </div>
              </div>
              <div className="col-lg-4 mr-4">
                <div className="row">
                  <span className="font-thai-r fs-18 c-gray">
                    {factupdate
                      ? language[locale]["sap_id"]
                      : content.soid.label}
                  </span>
                </div>
                <div className="row">
                  <Input
                    disabled={formdata.IsHold || false}
                    name="sap_id"
                    className="inputfile c-blue"
                    value={formdata.sap_id}
                    onChange={valuechange}
                  ></Input>
                </div>
              </div>
            </div>
          ) : null}

          <div className="row d-flex justify-content-left">
            {/* S/O ID */}
            {content.soid.show ? (
              <div className="col-lg-4 mr-4">
                <div className="row">
                  <span className="font-thai-r fs-18 c-gray">
                    {factupdate
                      ? language[locale]["so_id"]
                      : content.soid.label}
                  </span>
                </div>
                <div className="row">
                  <Input
                    disabled={formdata.IsHold || false}
                    name="soid"
                    className="inputfile c-blue"
                    value={formdata.soid}
                    onChange={valuechange}
                  ></Input>
                </div>
              </div>
            ) : null}
            {content.workcenter.show ? (
              <div className="col-lg-4 mr-4">
                <div className="row">
                  <span className="font-thai-r fs-18 c-gray">
                    {factupdate
                      ? language[locale]["workcenter"]
                      : content.workcenter.label}
                    <b style={{ color: "#DF4547" }}> * </b>
                  </span>
                </div>
                <div className="row">
                  <Select
                    disabled={formdata.IsHold || false}
                    name="workcenter"
                    className="dropdrowtype font-thai-r"
                    defaultValue={formdata.workcenter}
                    onChange={selectchange.bind(this, "workcenter")}
                    style={{ width: "100%" }}
                  >
                    {Work_center.map((data, index) => (
                      <Option
                        key={`sotype_option_b_${index}_${data.area_code}`}
                        value={data.work_center_id}
                      >
                        {data.work_center_code}
                      </Option>
                    ))}
                  </Select>
                </div>
              </div>
            ) : null}
          </div>
          <div className="row d-flex justify-content-left">
            {/* S/O ID */}
            {content.subcenter.show ? (
              <div className="col-lg-4 mr-4">
                <div className="row">
                  <span className="font-thai-r fs-18 c-gray">
                    {factupdate
                      ? language[locale]["subcenter"]
                      : content.subcenter.label}
                  </span>
                </div>
                <div className="row">
                  <Input
                    disabled={formdata.IsHold || false}
                    name="subcenter"
                    className="inputfile c-blue"
                    value={formdata.subcenter}
                    onChange={valuechange}
                  ></Input>
                </div>
              </div>
            ) : null}
            {content.alarmtype.show ? (
              <div className="col-lg-4 mr-4">
                <div className="row">
                  <span className="font-thai-r fs-18 c-gray">
                    {factupdate ? language[locale]["sla_level"] : `SLA Level`}
                  </span>
                  <b style={{ color: "#DF4547", marginLeft: "5px" }}> * </b>
                </div>
                <div className="row">
                  <Select
                    disabled={formdata.IsHold || false}
                    name="slalevel"
                    className="dropdrowtype font-thai-r"
                    defaultValue={formdata.slalevel}
                    style={{ width: "100%" }}
                    onChange={selectchange.bind(this, "slalevel")}
                  >
                    {sla.map((data, index) => (
                      <Option key={index} value={data.job_sla_id}>
                        {data.sla_name}
                      </Option>
                    ))}
                  </Select>
                </div>
              </div>
            ) : null}
          </div>
          <div className="row d-flex justify-content-left">
            <div className="col-lg-3 mr-3">
              <div className="row">
                <span className="font-thai-r c-gray fs-18">
                  {factupdate
                    ? language[locale]["standard_day"]
                    : `standard_day`}
                </span>
              </div>
              <div className="row">
                <Input
                  name="sla_time_day"
                  disabled
                  value={slatime.sla_time_day}
                  onChange={valuechange}
                ></Input>
              </div>
            </div>
            <div className="col-lg-3 mr-3">
              <div className="row">
                <span className="font-thai-r c-gray fs-18">
                  {factupdate
                    ? language[locale]["Standard Hour"]
                    : `Standard Hour`}
                </span>
              </div>
              <div className="row">
                <Input
                  disabled
                  name="sla_time_hour"
                  value={slatime.sla_time_hour}
                  onChange={valuechange}
                ></Input>
              </div>
            </div>
            <div className="col-lg-3 mr-3">
              <div className="row">
                <span className="font-thai-r c-gray fs-18">
                  {factupdate
                    ? language[locale]["standard_minute"]
                    : `standard_minute`}
                </span>
              </div>
              <div className="row">
                <Input
                  disabled
                  name="sla_time_min"
                  value={slatime.sla_time_min}
                  onChange={valuechange}
                ></Input>
              </div>
            </div>
          </div>
          <div className="row d-flex justify-content-left">
            <div className="col-lg-7" style={{ marginLeft: "0" }}>
              <div className="row">
                <span className="font-thai-r c-gray fs-18">
                  {factupdate ? language[locale]["priority"] : `Priority`}
                </span>
              </div>
              <div className="row">
                <Select
                  disabled={formdata.IsHold || false}
                  name="priority"
                  className="dropdrowtype font-thai-r"
                  defaultValue={formdata.priority}
                  onChange={selectchange.bind(this, "priority")}
                  style={{ width: "58%" }}
                >
                  {priority.map((data, index) => (
                    <Option
                      key={`priority_form_add_job${index}`}
                      value={data.priority_id}
                    >
                      {data.priority_name}
                    </Option>
                  ))}
                </Select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
